import i18n from '@/lang/index'

export default function RETURN_DATA() {
  return {
    nodes: [
      { code: 'INF', id: 'INF', title: i18n.t('nodes.inf'), activity: 'SHIPPING INFORMATION RECEIVED' },
      { code: 'RCV', id: 'RCV', title: i18n.t('nodes.rcv'), activity: 'RECEIVED SHIPMENT' },
      { code: 'SCN', id: 'SCN', title: i18n.t('nodes.scn'), activity: 'ITEM DESPATCHED TO TRANSSHIPMENT HUB' },
      { code: 'LHL', id: 'LHL', title: i18n.t('nodes.lhl'), activity: 'UPLIFTED FROM TRANSSHIPMENT HUB' },
      { code: 'SCN', id: 'SCNDES', title: i18n.t('nodes.scnDes'), activity: '', invented_code: 'SCN_DES' },
      { code: 'DLD', id: 'DLD', title: i18n.t('nodes.dld'), activity: '' }
    ]
  }
}
